import { toast } from "react-toastify";
import * as Yup from "yup";
import SessionManager from "./Session";

export const InputType = {
  email: "email",
  password: "password",
  text: "text",
  number: "number",
  date: "date",
  terms: "terms",
  accountNumber: "accountNumber",
};

export const htmlToText = (string) => {
  return string?.replace(/<[^>]+>/g, "") ?? "";
};

export const handleApiErrors = (error) => {
  const statusCode = error?.response?.status;
  if (statusCode) {
    switch (statusCode) {
      case 401:
        SessionManager.shared.logout();
        break;
      case 400:
        toast.error(error?.response?.data?.error);
        break;
      default:
        break;
    }
  }
};
const generatePasswordValidation = () => {
  return Yup.string()
    .trim()
    .required("Field can't be empty!")
    .min(6, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]+$/,
      "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
    );
};



export const validationRegex = {
  email: Yup.string()
    .trim()
    .required("Field can't be empty!")
    .email("Entered Email is Invalid!")
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Entered Email is Invalid!"),
  password: generatePasswordValidation(),
  currentPassword: generatePasswordValidation(),
  newPassword: generatePasswordValidation(),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm Password is required"),
  required: Yup.string().trim().required("Field can't be empty!"),
  mobile: Yup.string()
    .trim()
    .required("Field can't be empty!")
    .matches(/^[6-9]\d{9}$/, "Entered Mobile Number is Invalid!"),
  required: Yup.string().trim().required("Field can't be empty!"),
  date: Yup.string().required("Field can't be empty!"),
  terms: Yup.boolean()
    .oneOf([true], "You must accept the terms and conditions!")
    .required("You must accept the terms and conditions!"),
  dob: Yup
    .string()
    .required("Field can't be empty!")
    .test('DOB', 'Cannot select future date!', value => {
      return new Date(value).getTime() < new Date().getTime();
    }),
  accountNumber: Yup.string()
    .trim()
    .required("Field can't be empty!")
    .matches(/^\d{10,20}$/, "Account number must be between 10 and 20 digits long"),

  confirmaccountnumber: Yup.string()
    .trim()
    .required("Confirm Account Number is required!")
    .oneOf([Yup.ref('accountnumber')], "Account Number and Confirm Account Number must match"),
  ifscCode: Yup.string()
    .trim()
    .required("Field can't be empty!")
    .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Entered IFSC code is invalid!"),
  pannumber: Yup.string()
    .trim()
    .required("Field can't be empty!")
    .matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, "Entered PAN Number is invalid!"),
};

